import ApiClient from '@/helpers/ApiClient';
import type { WorkspaceQuotaStatusData } from '@/types/billing/workspace-quota-status.types';

import type { ItemResponse } from '@bv/api/base';
import type { AxiosResponse } from 'axios';

export enum Module {
  BROADCAST = 'broadcast',
  CONVERSATION = 'mac',
  WORKFLOW = 'workflow',
}

type ModuleQuotaStatusAxiosResponse = AxiosResponse<ItemResponse<WorkspaceQuotaStatusData>>;

class BillingApi extends ApiClient {
  constructor() {
    super('conversations/billing');
  }

  async getModuleQuotaStatus(module: Module): Promise<WorkspaceQuotaStatusData> {
    const { data } = await this.get<ModuleQuotaStatusAxiosResponse>({}, `workspace/quota-status/${module}`);
    return data.data;
  }
}

export default new BillingApi();
